import { ACTION_MENU_ITEM_CLASS_NAME, ActionMenuItem, ActionMenuItemProps } from '@systemeio/ui'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { twMerge } from 'tailwind-merge'

type ActionMenuLinkItemProps = Omit<
  ActionMenuItemProps,
  'label' | 'onClick' | 'buttonClassName' | 'labelClassName'
> & {
  isNext?: boolean
  label: string | JSX.Element
  href: string
  openInNew?: boolean
  dataTestAttributes?: Record<string, string>
}

export const ActionMenuLinkItem = ({
  label,
  href,
  openInNew,
  dataTestAttributes,
  isNext,
  ...props
}: ActionMenuLinkItemProps) => (
  <ActionMenuItem {...props}>
    {({ focus }) => (
      <LinkWithoutPrefetch
        type="button"
        aria-pressed={focus}
        href={href}
        className={twMerge(
          ACTION_MENU_ITEM_CLASS_NAME,
          props.disabled && 'hover:text-text-secondary text-text-secondary cursor-not-allowed',
        )}
        {...dataTestAttributes}
        {...(openInNew ? { target: '_blank', rel: 'noreferrer' } : {})}
      >
        {label}
      </LinkWithoutPrefetch>
    )}
  </ActionMenuItem>
)
